// TODO the same stupid pattern is repeated in every action; I extracted this
// function to DRY them but most actions don't use it yet:

const parseResponse = promise => promise.then(response => Promise.resolve(response.data)).catch(e => Promise.reject(e.response));
export default parseResponse;